module.exports = __webpack_public_path__ + "static/media/handshake-icon.ac6650d4.svg";